module.exports = __webpack_public_path__ + "img/second-place.03cadc31.jpg";